export const currentAccount = {
    currentAccountTicketingService: {
        enabled: true,
        _description:
            'controls the rendering of ticketing container on current account settings page',
    },

    freeCashWithdrawal: {
        enabled: false,
        _description:
            'controls the rendering of free cash withdrawal container on current account settings page',
    },

    secondaryIdManagement: {
        enabled: false,
        _description:
            'controls the rendering of secondary id routes on current account and cards settings page',
    },

    requestToPay: {
        enabled: false,
        _description: 'probably outdated, further investigation needed',
    },

    roundupSavings: {
        enabled: true,
        _description: 'controls the rendering of rounding savings from the routing point',
    },

    currentAccountOverdraftSetup: {
        enabled: false,
        _description: 'controls the render of setup overdraft function card',
    },

    currentAccountOverdraftChange: {
        enabled: false,
        _description: 'controls the render of change overdraft button in function card',
    },

    moneyAside: {
        enabled: false,
        _description: 'controls the rendering of money aside from the routing point',
    },
    currentAccountArchive: {
        enabled: false,
        _description: 'allow rendering of legacy accounts as readonly archive',
    },
    currentAccountInsurance: {
        enabled: false,
        _description: 'enables the bill protection insurance feature',
    },
    currentAccount: {
        associatedCards: {
            enabled: true,
            _description: 'enables for current account to have associated cards',
        },
    },
};
